import React from "react";
import { Link } from "react-router-dom";
import UserAvatar from "../../../user/UserAvatar";
import Icon from "../../../icon/Icon";
import { DropdownMenu, DropdownToggle, DropdownItem, UncontrolledDropdown, CardTitle } from "reactstrap";
import { findUpper } from "../../../../utils/Utils";

const NewsUsers = ({ data, heading, viewAllTo }) => {
  const DropdownTrans = () => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger me-n1">
          <Icon name="more-h"></Icon>
        </DropdownToggle>
        <DropdownMenu end>
          <ul className="link-list-opt no-bdr">
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                <Icon name="setting"></Icon>
                <span>Action Settings</span>
              </DropdownItem>
            </li>
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                <Icon name="notify"></Icon>
                <span>Use Notification</span>
              </DropdownItem>
            </li>
          </ul>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };
  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="card-title-group">
          <CardTitle>
            <h6 className="title">{heading ?? "Recent users"}</h6>
          </CardTitle>
          <div className="card-tools">
            {viewAllTo ? (
              <Link to={viewAllTo} className="link">
                View all
              </Link>
            ) : (
              <span className="text-soft small">Latest five</span>
            )}
          </div>
        </div>
      </div>
      {(data || []).map((item, idx) => {
        return (
          <div className="card-inner card-inner-md" key={item.id ?? idx}>
            <div className="user-card">
              <UserAvatar theme={item.theme} text={findUpper(item.name || item?.phone)}></UserAvatar>
              <div className="user-info">
                <span className="lead-text">{item.name}</span>
                <span className="sub-text">{item.phone}</span>
              </div>
              <div className="user-action">
                <DropdownTrans />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default NewsUsers;
